var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info_icon",on:{"mouseover":function($event){_vm.isHovering = true},"mouseleave":function($event){_vm.isHovering = false}}},[_vm._t("icon"),(_vm.isHovering)?_c('div',{staticClass:"info_icon_description"},[_vm._v(_vm._s(_vm.description)+" "),_vm._t("description")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }